import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CatalogObject, IconDetail } from '@mirage-projects/cw-models';
export interface CardElement {
    catalogObject: CatalogObject;
    iconDetail?: IconDetail[];
}

/** This components displays a list of cards associated to catalogs*/
@Component({
    selector: 'cw-card-list',
    templateUrl: './card-list.component.html',
    styleUrls: ['./card-list.component.scss'],
    standalone: false,
})
export class CardListComponent {
    /** Title of the card list */
    @Input() title: string | undefined;

    /** Elements to show in each cards */
    @Input() elements!: CardElement[];

    /** If this input is true, a spiner loader will be displayed */
    @Input() isLoading = false;

    /** If this input is setted an error message will be displayed */
    @Input() msgError: string | undefined;

    /** This event will be emitted when clicking in a card */
    @Output() clickElement = new EventEmitter<CatalogObject>();

    onClickElement(catalogObject: CatalogObject): void {
        this.clickElement.emit(catalogObject);
    }
}
